import { render } from "./BaseLatexElement.vue?vue&type=template&id=4118f3dd&scoped=true&ts=true"
import script from "./BaseLatexElement.vue?vue&type=script&lang=ts"
export * from "./BaseLatexElement.vue?vue&type=script&lang=ts"

import "./BaseLatexElement.vue?vue&type=style&index=0&id=4118f3dd&lang=scss&scoped=true"

import exportComponent from "D:\\zhangjc\\zhangjc_pro\\Edensoft.AIManage\\Edensoft.AIManageGit\\Edensoft.AIManage\\Edensoft.AIManage.PPTCopilot.PPTist.Apache-2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4118f3dd"]])

export default __exports__